module.exports = __webpack_public_path__ + "static/assets/353e5c7e9c195515b403257ba25745ab.svg";